import { useEffect, useState, useContext, useRef } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import * as icons from "react-icons/md";
import { useLocation } from "react-router-dom";

import { AppContext } from "../Context";
import Fetch, { Loader, dateToText } from "../inc/Fetch";
import { Img, Tasks } from "../components/Elements";

import Header from "./Header";
import Footer from "./Footer";

import { BsTextCenter } from "react-icons/bs";
import { TbMath, TbMusic } from "react-icons/tb";
import { RiMusicFill } from "react-icons/ri";
import { IoLanguageSharp } from "react-icons/io5";

import "./css/main.css";

export default function Home({ data, article }) {
    const player = useRef();
    const { userData } = useContext(AppContext);
    const [userinfo, setuserinfo] = userData;

    const location = useLocation();
    const path = location.pathname;

    const [playing, setplaying] = useState(true);

    function playPause() {
        if (player?.current?.paused) {
            setplaying(true);
            player.current?.play();
        } else {
            player.current?.pause();
            setplaying(false);
        }
    }

    return (
        <>
            <a tabIndex="0" onClick={playPause} className="pauseBox">
                {playing ? <icons.MdPause /> : <icons.MdPlayArrow />}
            </a>

            <video
                src="/vid12.mp4"
                ref={player}
                className="backgroundVideo"
                playsInline
                muted
                loop
                autoPlay
            ></video>
            <section style={{ overflow: "unset" }} className={`main`}>
                <Header article={article} main={true} />

                <div className="mainWidth">
                    <nav className="bottomMenu">
                        {data?.cats?.map((v, k) => {
                            if (!v?.status?._id) return;

                            if (!v?.colors) {
                                v.colors = { "--menu-color": "#000" };
                            }

                            let ck = "";
                            if (data?.cats?.length == 1) {
                                ck = "ck";
                            }

                            let Icon = icons[v?.icon];

                            return (
                                <Link
                                    className={ck || "null"}
                                    to={`/site/${v?.name}`}
                                    key={k}
                                >
                                    <Icon
                                        style={{
                                            backgroundColor:
                                                v?.colors["--menu-color"],
                                        }}
                                    />
                                    <h4>{v?.name}</h4>
                                    <p>{v?.full?.substring(0, 120)}</p>
                                    <button
                                        style={{
                                            backgroundColor:
                                                v?.colors["--menu-color"],
                                        }}
                                        className="btn"
                                    >
                                        ابدأ الآن...
                                    </button>
                                </Link>
                            );
                        })}

                        {/* 
                        <Link to="/site" className='color-orange'>
                            <TbMath/>
                            <h4>موقع الرياضيات</h4>
                            <p>تعلم الموسيقى هو تجربة ممتعة وثرية تتيح للأفراد التعبير عن مشاعرهم والإبداع. إليك بعض الخطوات والنصائح لتسهيل عملية تعلم الموسيقى:</p>
                            <button className='btn'>ابدأ الآن...</button>
                        </Link> */}

                        {/* <Link to="/Music" className='color-blue'>
                            <RiMusicFill />
                            <h4>موقع الموسيقى</h4>
                            <p>تعلم الموسيقى هو تجربة ممتعة وثرية تتيح للأفراد التعبير عن مشاعرهم والإبداع. إليك بعض الخطوات والنصائح لتسهيل عملية تعلم الموسيقى:</p>
                            <button className='btn'>ابدأ الآن...</button>
                        </Link>

                        <Link to="/Music" className='color-green'>
                            <BsTextCenter />
                            <h4>موقع العبرية</h4>
                            <p>تُعتبر اللغة الإنجليزية واحدة من أكثر اللغات تحدثًا وانتشارًا في العالم، وهي تُستخدم في مجالات متنوعة مثل الأعمال،</p>
                            <button className='btn'>ابدأ الآن...</button>
                        </Link>

                        <Link to="/Music" className='color-red'>
                            <IoLanguageSharp />
                            <h4>موقع الانجليزية</h4>
                            <p>تعلم الموسيقى هو تجربة ممتعة وثرية تتيح للأفراد التعبير عن مشاعرهم والإبداع. إليك بعض الخطوات والنصائح لتسهيل عملية تعلم الموسيقى:</p>
                            <button className='btn'>ابدأ الآن...</button>
                        </Link> */}
                    </nav>
                </div>
            </section>
        </>
    );
}
